import { z } from 'zod'
import { mcpToolNameSchema } from '../enums/mcp-tool-name.enum.js'
import { instantSchema } from '../validators/temporal.validator.js'

/**
 * Something a connection changed through an MCP tool, as the person who
 * approved the connection sees it. See docs/mcp-server.md, slice 4.
 */
export const mcpWriteDtoSchema = z.object({
  id: z.string().uuid(),
  /** The tool, as the connector called it (`update_plan`). */
  tool: mcpToolNameSchema,
  /** What changed, as a person reads it: which plan of which event, and how. */
  summary: z.string(),
  /** The event and plan it changed, for a way back to them; null when it was neither. */
  eventId: z.string().nullable(),
  phaseId: z.string().nullable(),
  createdAt: instantSchema,
})
export type McpWriteDto = z.infer<typeof mcpWriteDtoSchema>

export const mcpWriteListDtoSchema = z.object({
  /** Newest first. */
  writes: z.array(mcpWriteDtoSchema),
})
export type McpWriteListDto = z.infer<typeof mcpWriteListDtoSchema>
